import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { IMAGE_BASE } from '../../services/api';
import { Check, ArrowRight } from 'lucide-react';

function CartIcon({ count }) {
    return (
        <span className="cart-bottom-icon-wrap">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <path d="M16 10a4 4 0 01-8 0" />
            </svg>
            {count > 0 && <span className="cart-bottom-icon-badge">{count}</span>}
        </span>
    );
}

export default function CartBottomBar() {
    const { cart, lastAddedItem, setSidebarOpen } = useCart();
    const [showAdded, setShowAdded] = useState(false);
    const [pulse, setPulse] = useState(false);

    useEffect(() => {
        if (!lastAddedItem) return;
        setShowAdded(true);
        setPulse(true);
        const t1 = setTimeout(() => setShowAdded(false), 3000);
        const t2 = setTimeout(() => setPulse(false), 600);
        return () => { clearTimeout(t1); clearTimeout(t2); };
    }, [lastAddedItem]);

    const visible = cart.itemCount > 0;

    const formatPrice = (p) => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 0 }).format(p);
    const getImageUrl = (url) => url?.startsWith('http') ? url : IMAGE_BASE + url;

    return (
        <div className={`cart-bottom-bar ${visible ? 'open' : ''}`}>
            <div className="cart-bottom-bar-inner">
                <div className="cart-bottom-bar-left">
                    {showAdded && lastAddedItem?.image ? (
                        <img src={getImageUrl(lastAddedItem.image)} alt="" className="cart-bottom-bar-img" />
                    ) : (
                        <div className={`cart-bottom-bar-icon${pulse ? ' pulse' : ''}`}>
                            <CartIcon count={cart.itemCount} />
                        </div>
                    )}
                    <div className="cart-bottom-bar-info">
                        {showAdded ? (
                            <>
                                <span className="cart-bottom-bar-check"><Check size={14} /> Sepete eklendi</span>
                                {lastAddedItem && <span className="cart-bottom-bar-name">{lastAddedItem.productName}</span>}
                            </>
                        ) : (
                            <>
                                <span className="cart-bottom-bar-summary">Sepetinizde {cart.itemCount} ürün</span>
                                <span className="cart-bottom-bar-total-text">{formatPrice(cart.totalAmount)}</span>
                            </>
                        )}
                    </div>
                </div>
                <div className="cart-bottom-bar-right">
                    <button className="cart-bottom-bar-view" onClick={() => setSidebarOpen(true)}>
                        Sepeti Gör
                    </button>
                    <Link to="/checkout" className="cart-bottom-bar-checkout">
                        Siparişi Tamamla <ArrowRight size={15} />
                    </Link>
                </div>
            </div>
        </div>
    );
}
